import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/servicios.service";

const initialState = {
    servicios: [],
    isLoading: false,
    isError: false,
    message: '',
    currentPage: 1,
    totalRows: 0,
};



export const createServicio = createAsyncThunk(
    "servicio/create",
    async (data, thunkAPI ) => {
        try {
            return await service.createServicio(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const getServicios = createAsyncThunk(
    "servicios/getServicios",
    async (data, thunkAPI) => {
        try {
            return await service.getAllServicios(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const updateServicio = createAsyncThunk(
    "servicio/update",
    async (data, thunkAPI ) => {
        try {
            const token = thunkAPI.getState().auth.user.token;
            return await service.updateServicio(data, token);
        } catch (error) {
            const message = (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const deleteServicio = createAsyncThunk(
    "servicio/deleteServicio",
    async (id, thunkAPI) => {
        try {
            return await service.deleteServicio(id);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const serviciosSlice = createSlice({
    name: "servicios",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getServicios.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getServicios.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.servicios = action.payload.data; // Asegúrate de que el backend retorne los datos bajo esta estructura
                state.currentPage = action.payload.pagination.por_pagina;
                state.totalRows = action.payload.pagination.cantidad;
            })
            .addCase(getServicios.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createServicio.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createServicio.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.servicios.push(action.payload);
            })
            .addCase(createServicio.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteServicio.fulfilled, (state, action) => {
                state.isLoading = false;
                state.servicios = state.servicios.filter(servicio => servicio.id !== action.meta.arg); // Opcional si quieres filtrar localmente
            })
            .addCase(deleteServicio.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error eliminando el servicio';
            })
            .addCase(updateServicio.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateServicio.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.servicios = state.servicios.map((servicio) => 
                servicio.id === action.payload.id ? action.payload : servicio);
            })
            .addCase(updateServicio.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
    }
})

export const { reset } = serviciosSlice.actions;
export default serviciosSlice.reducer;